import React from "react";

export default () => (
  <div className="px-5">
    <h1 className="display-4">Permission Error</h1>
    <p>Sorry, You can"t access this page.</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/views/pages/permission-error.js